<template>
  <div class="w-100">
        <div class=" p-list-representation-wrapper align-items-start">
          <Loader class="w-100" :loading="loading">
            <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
              <div class="w-100" >
                <appHeader></appHeader>
              </div>

              <div class=" row p-list-representation-data w-100"   :key="updateFormData">
                <contentList
                  :form-data="formData"
                  :status-table-data="statusTableData"
                  :gender-data="genderData"
                  :value-title-location="valueTitleLocation"
                  :team-all="teamAll"

                  @titleLocation="titleLocation"
                  @latLngCallBack="latLngCallBack"
                  @removeLocation="removeLocation"
                  @submitLocation="submitLocation"
                  @submitData="submitData"
                  @searchSecondTeam="searchSecondTeam"
                ></contentList>
              </div>

            </div>
          </Loader>

        </div>

  </div>
</template>

<script>
import contentList from '../components/entryAndEditListGameFuture/contentList';
import appHeader from '../components/includes/AppHeader';



export default {
  name: "entryAndEditListGameFuture",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  // $todo check city id profile //
  // Alternative initial city id //
  data() {
    return {
      loading           : false,
      formData          : {
        cup_id         : '',
        first_team_id  : '',
        second_team_id : '',
        refree_name    : '',
        location       : '',
        lat            : '',
        lng            : '',
        being_hold_at  : '',
        image          : '',
        locations      : [],
        title          : '',
        id             : -1,
      },
      statusTableData   : [
        {
          id    : 'joining',
          title : 'در حال عضوگیری	',
        },
        {
          id    : 'held',
          title : 'فعال',
        },
        {
          id    : 'being_held',
          title : 'به پایان رسیده',
        },
      ],
      genderData        : [
        {
          id    : 'male',
          title : 'آقایان',
        },
        {
          id    : 'female',
          title : 'بانوان',
        }
      ],
      valueTitleLocation    : "",
      counterCreateLocation : 0,
      updateFormData        : 0,
      teamAll               : [],
      teamData              : {
        page      : 1,
        full_name : '',
      }

    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
    const singleCupData       = localStorage.getItem('gameFutureSingle');
    const jsonConvertToObject =  JSON.parse(singleCupData);
    const getParamsId         = this.$route.params.id;
    const getParamsCupId      = this.$route.params.cup_id;

    if (typeof(getParamsId) != 'undefined') {
      jsonConvertToObject.locations = [];
      this.formData       = jsonConvertToObject;
      this.updateFormData++;
    }
    else {
      this.formData.cup_id = getParamsCupId;
    }


    this.getTeams();
  },

  methods: {
    convertTimeStampInToJalali(data){
        const resultConvert    = this.$moment.unix(data.being_hold_at).format("jYYYY/jMM/jDD HH:mm:ss").split(' ');
        data.beingHoldJalali   =  resultConvert[0];
    },

    submitData(data){
      if (data.image != null) {
        if (typeof(data.image.name) == 'undefined') {
          delete data.image;
        }
      }

      if (data.image == null) {
        delete data.image;
      }

      if (data.id == -1) {
        delete data.id;
      }

      data.locations.map((t)=>{
        data.lat = t.lat;
        data.lng = t.lng;
        data.location = t.title;
      })


      this.formData           = data;
      this.loading            = true;


      this.$store
      .dispatch('gameTab/entryAndEdit', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading   = false;

        if (res.is_successful) {
          localStorage.setItem("gameFutureSingle", JSON.stringify(res));
          this.$message.success(res.message);
          this.$router.push({name:'listCups'})
        }
        else {
          if (typeof(res.is_successful) != 'undefined') {
            // let concatMessage = '';
            // for (let key in res.message) {
            //   const contentError = res.message[key];
            //   concatMessage+=contentError + ',';
            // }
            this.$message.error(res.message)
          }

        }

      })
    },

    titleLocation(value){
      this.valueTitleLocation = value;
    },

    latLngCallBack(value){
      this.formData.locations = [];
      const newLocation       = value;
      newLocation.title       = this.valueTitleLocation;
      this.counterCreateLocation++;
      newLocation.id          = this.counterCreateLocation;
      this.valueTitleLocation = '';

      this.formData.locations.push(newLocation);
    },

    removeLocation(data){
      let findIndexRemoveLocation = -1;

      this.formData.locations.map((t,i)=>{
        if (data.id == t.id) {
          findIndexRemoveLocation = i;
        }
      });

      this.formData.locations.splice(findIndexRemoveLocation,1);
    },

    submitLocation(data){
      this.submitData(data);
    },

    getTeams(){
      this.loading      = true;

      this.$store
      .dispatch('teams/getTableData', {
        data : {
          ...this.teamData
        }
      })
      .then((res)=>{
        this.loading = false;
        this.teamAll = res.data;
      })
    },

    searchSecondTeam(data){

    }



  }


}
</script>
